export function SET_DATA(state, payload) {
  state[payload.state] = payload.data;
}
export function TOGGLE_DIALOG(state) {
  state.isFormDialogOpen = !state.isFormDialogOpen;
}